module.exports = __webpack_public_path__ + "img/clean.c5ce81e.png";